function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  fillRule: "evenodd"
}, React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 19.5,
  stroke: "#FFF",
  fill: "none"
}), React.createElement("path", {
  fillRule: "nonzero",
  d: "M16.13 17.482V26h-3.047v-8.518h3.047zm5.563 0v1.189c.392-.694 1.179-1.189 2.653-1.189 1.475 0 2.654 1.189 2.654 3.862V26h-2.949v-4.656c0-1.287-.788-1.585-1.082-1.585-.295 0-1.276.2-1.276 1.585V26h-3.048v-8.518h3.048zM14.656 13c.931 0 1.552.627 1.552 1.462 0 .834-.62 1.459-1.656 1.459-.931 0-1.552-.625-1.552-1.46 0-.834.62-1.461 1.656-1.461z"
}));

function SvgIninline(props) {
  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40"
  }, props), _ref);
}

export default SvgIninline;